<template>
  <owal-modal-panel
    :title="title"
    :bottom-buttons="bottomButtons"
    style="z-index:2000"
    >
    <div
      style="display: flex; flex-direction: column;"
      @keyup.enter="accept"
      @keyup.esc="cancel"
      :tabindex="0"
      >
      <div
        v-if="!entryIsValid"
        style="width: 100%; text-align: center; color: red;"
        >
          {{ errorMessage }}
        </div>
      <div
        style="display: flex; flex-direction: row; justify-content: space-around;">
        <label
          v-show="message"
          >
          {{ message }}
        </label>
        <owal-text-input
          :style="`${message ? '' : 'width: 90%;'}`"
          :identifier="'prompt'"
          ref="pinInput"
          type="text"
          :placeholder="placeholder"
          @input="updateInput"
          />
    </div>
    </div>
  </owal-modal-panel>
</template>

<script>
import { OwalModalPanel } from '@/libraries/owal-ui/panels'
import { OwalTextInput } from '@/libraries/owal-ui/inputs'

export default {
  name: 'OwalInputPrompt',
  components: { OwalModalPanel, OwalTextInput },
  props: {
    /**
     * @prop {Number} title The title of the prompt window.
     * */
    title: {
      type: String,
      default: 'OWAL says',
    },
    /**
     * @prop {String} message Message to user preceding text input.
     */
    message: {
      type: String,
      default: '',
    },
    /**
     * @prop {String} default Default value provided to input.
     */
    placeholder: {
      type: String,
      default: '',
    },
    /**
     * @prop {Array} invalidInputs Array of strings to check against that are invalid entries.
     */
    invalidInputs: {
      type: Array,
      default: undefined,
    },
    /**
     * @prop {String} errorMessage Error message upon invalid entry.
     */
    errorMessage: {
      type: String,
      default: 'is not a valid entry.',
    },
  },
  data () {
    return {
      userInput: undefined,
    }
  },
  computed: {
    bottomButtons () {
      const buttons = [
        {
          identifier: 'cancel',
          title: 'Cancel', /*  */
          callback: this.cancel,
        },
      ]
      if (this.entryIsValid) {
        buttons.push({
          identifier: 'accept',
          title: 'Ok',
          callback: this.accept,
        })
      }
      return buttons
    },
    entryIsValid () {
      // if we don't want empty strings, pass that in as an option
      // for optiomal performance, pass in a placeholder string
      let failing = false
      const userInputExists = this.userInput && this.userInput.length > 0
      if (this.invalidInputs && userInputExists) {
        failing = this.invalidInputs.some(title => {
          const match = this.userInput.toLowerCase() === title.toLowerCase()
          return match
        })
        return !failing
      } else if (!failing) {
        const placeholderExists = this.placeholder.length > 0
        return placeholderExists
      } else return true
    },
  },
  methods: {
    cancel () {
      this.userInput = undefined
      this.$emit('cancel')
    },
    accept () {
      const output = this.userInput || this.placeholder
      this.$emit('ok', output)
    },
    updateInput (value) {
      this.userInput = value
    },
  },
}
</script>

<style>
</style>
